import {
  UPDATE_EXTERNAL_FEE_PAYMENT_REDUCER,
  RESET_EXTERNAL_FEE_PAYMENT_REDUCER,
} from "../actions";

const INITIAL_STATE = {
  isLoading: false,
  institutesList: [],
  selectedStudentId: "",
  instituteId: "",
};

const externalFeePaymentReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_EXTERNAL_FEE_PAYMENT_REDUCER:
      return { ...state, ...action.payload };
    case RESET_EXTERNAL_FEE_PAYMENT_REDUCER:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default externalFeePaymentReducer;
